import { useEffect, React } from "react";
import { domReady } from "../../helper/domReady";
import Portal from "../../globalComponents/Portal";
import { HeroBanner300px } from "../../globalComponents/300pxHeroBanner";
import './style.css'
import { addPageClass } from "../../helper/addPageClass";
const SessionCatalog = (props) => {
  const contentContainer = document.querySelector(".rf-org-header-container");
   
  // domReady(() => {
  //   console.log("found dropdown span")
  //   let dropDownContainer = document.querySelectorAll("[id*='rf-'].rf-widget .catalog-result .catalog-result-title button .arrow-toggle");
  //   console.log(dropDownContainer)
  //   const config = { attributes: true, childList: true, subtree: true };

  //   dropDownContainer.forEach(element => {
  //     new MutationObserver(() => {
  //       if (element.className.includes("arrow-toggle-collapsed")) {
  //         element.innerHTML = "<p class='color=[#C432F0]'>Show More</p>";
  //       }else{
  //         element.innerHTML = "<p class='color=[#C432F0]'>Show Less</p>";
  //       }
  //     }).observe(element, config);
  //   })
    
  // }, "[id*='rf-'].rf-widget .catalog-result .catalog-result-title button .arrow-toggle");
  
  useEffect(() => {
    addPageClass("sessionsPage");
  });
  
  return (
    <>
      <Portal container={contentContainer}>
        <HeroBanner300px
          h1={"Browse Sessions"}
          p={
            "Browse through the event content to discover insight-filled keynotes, technical sessions and panels, hands-on labs and poster chats."
          }
          p2={
            "Only hands-on labs require reserved seating by clicking Add to Agenda."
          }
          p3={
            "Click the heart icon to favorite a session and build a personalized schedule."
          }
          backgroundImgUrl={
            "https://static.rainfocus.com/intel/innovation2022/static/staticfile/staticfile/hero%20img%20bg%20innovation-2022_16595494141090019H1e.png"
          }
          env={props.env}
        />
      </Portal>
    </>
  );
};

export { SessionCatalog };
